export const gistActionTypes = {
    /**
     * Gist get constants
     */
    GET_GIST_REQUEST: 'GISTS_GET_GIST_REQUEST',
    GET_GIST_SUCCESS: 'GISTS_GET_GIST_SUCCESS',
    GET_GIST_FAILURE: 'GISTS_GET_GIST_FAILURE',

    /**
     * Hide current gist
     */
    UNSET_CURRENT_GIST: 'GISTS_HIDE_CURRENT_GIST',

    /**
     * For source details : Gist get constants
     */
    GET_SOURCE_GIST_REQUEST: 'GISTS_SOURCE_GET_GIST_REQUEST',
    GET_SOURCE_GIST_SUCCESS: 'GISTS_SOURCE_GET_GIST_SUCCESS',
    GET_SOURCE_GIST_FAILURE: 'GISTS_SOURCE_GET_GIST_FAILURE',

    /**
     * For source details : Hide current gist
     */
    UNSET_SOURCE_CURRENT_GIST: 'GISTS_HIDE_CURRENT_GIST',
};